import { Page } from '@/core/architecture'

import { UserProfileTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * UserProfile Page
 * Implemented as a practical sample.
 */
export const UserProfile: Page = () => {
  const { state } = useViewModel()

  return <UserProfileTemplate state={state} />
}
